import { Column, ColumnKeys, ReadTagsResponse, TagItem, TagsMethods } from '../types';
import {
  GetRowsRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { ConsoleRequest, DataProviderType, FilterKeyMapper } from 'apps/webcomponents/src/utils/request';
import { Dependencies } from '../../types/dependencies';
import { API_TYPE_COMPANIES_FOR_GZ_TAGS } from '../../../webcomponents.constants';

export class TagsManagerGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private endpoint = 'GzTags';
  private cache: ReadTagsResponse | null;
  public companyFilterDataProvider = API_TYPE_COMPANIES_FOR_GZ_TAGS;

  /**
   * Maps column key to different filter key as we filter with a different one.
   */
  private filterKeyMapper: FilterKeyMapper = {
    'company.name': 'company.id',
  };

  constructor(public dependencies: Dependencies) {
    super();
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    const response = await this.readRecords(request);

    return { numItems: response.total, summary: '' };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<TagItem> }> {
    const response = await this.readRecords(request);

    return { rawEvents: response.data };
  }

  async setFilters(request: any): Promise<{} | undefined> {
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  private async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<ReadTagsResponse> {
    if (this.cache) {
      const response = Promise.resolve(this.cache);
      this.cache = null;

      return response;
    }

    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone(), this.filterKeyMapper);
    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: TagsMethods.READ_RECORDS,
    });

    this.cache = response;

    return response;
  }
}
